<fieldset class="u-fade-slide-in">
  <h4>{{ 'recommendation_block.header' | translate | upperFirstLetter }}</h4>
  @if (contentType() === 'scenic') {
  <div class="recommendation-block">
    <div class="title">
      <kin-icon name="play" [color]="colorService.textColor() || 'white'" />
      <h5>{{ 'recommendation_block.title' | translate | upperFirstLetter }}</h5>
      <kin-toggle-switch size="small" [leftText]="'common.yes' | translate" [rightText]="'common.no' | translate" bgColor="#428FF3" bgFalseColor="#7E8184"
        [textColor]="'#1a1918'" [active]="recommendationModeActive" (onClick)="recommendationModeSelection($event)" />
    </div>
    <p>{{ 'recommendation_block.subtitle' | translate | upperFirstLetter }}</p>
  </div>
  @if (recommendationModeActive) {
  <app-input-radio-element [elementsList]="recommendationItemList"
    [selectedValue]="recommendationForm().get('speedMode')?.value" (valueChange)="recommendationChange($event)" />
  }
  <div class="divider"></div>
  }
  <div class="audio-block">
    <div class="title">
      <kin-icon name="audio" [color]="colorService.textColor() || 'white'" />
      <h5>{{ 'recommendation_block.audio.title' | translate | upperFirstLetter }}</h5>
      <kin-toggle-switch size="small" [leftText]="'common.yes' | translate" [rightText]="'common.no' | translate" bgColor="#428FF3" bgFalseColor="#7E8184"
        [textColor]="'#1a1918'" [active]="audioActive" (onClick)="audioSelection($event)" />
    </div>
    <p class="subtitle">{{ 'recommendation_block.audio.subtitle' | translate }}</p>
  </div>

  @if (audioActive) {
  <app-input-radio-element [elementsList]="audioItemList" [selectedValue]="recommendationForm().get('audioMode')?.value"
    (valueChange)="audioChange($event)" />
  }
</fieldset>